import { useQuery } from '@tanstack/react-query';

import { getChatById } from '~/services/SupportService';

export const chatQueryKeys = {
  all: ['chats'] as const,
  details: () => [...chatQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...chatQueryKeys.details(), id] as const,
};

interface UseGetChatByIdParams {
  chatId: string | null;
}

export function useGetChatById({ chatId }: UseGetChatByIdParams) {
  return useQuery({
    queryKey: chatQueryKeys.detail(chatId ?? ''),
    queryFn: async () => {
      const { result } = await getChatById(chatId);
      return result;
    },
    enabled: !!chatId,
  });
}
